import React from 'react';
import './operators-list.scss';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { MultiSelectOption } from '../../../../global/multi-select-list/_multi-select-option';
import { OperatorStatus } from '../../../../../api/control.dao';
import Text from '../../../../global/text/text';
import { IUserOperatorDTO, OperatorRole } from '../../../../../api/operators.dao';
import { OperatorsRoleDropdownPresentation } from './_operator-role-dropdown/operator-role-dropdown.presentation';
import { CloseIcon } from '../../../../global/icons/icons';

interface IProps {
    operators: IUserOperatorDTO[];
    onOperatorStatusChange?: (email: string) => void;
    canChangeOperatorStatus?: boolean;
    removeOperator?: (email: string) => void;
    onOperatorRoleChange?: (email: string, role: OperatorRole) => void;
    displayOperatorRole?: boolean;
    withCloseIcone?: boolean;
    classname?: string;
}

const OperatorsList = (props: IProps) => {
    const withoutMultiSelectOption = classnames({'operators-list__item--space-between': !props.canChangeOperatorStatus });
    const withBorders = classnames({ 'operators-list--with-borders': props.operators.length && !!props.canChangeOperatorStatus });
    const { formatMessage } = useIntl();
    const { classname = '' } = props;

    return (
            <div className={classnames('operators-list', withBorders, classname)}>
                {
                    props.operators.length ? (props.operators
                        .slice()
                        .sort((a, b) => a.lastName.localeCompare(b.lastName))
                        .map(operator => {
                            let activeOperator = true;
                            if (operator?.user?.active !== undefined) {
                                activeOperator = operator.user.active;
                            }
                            return <div key={operator.email} className={classnames('operators-list__item', withoutMultiSelectOption)}>
                                {
                                    props.canChangeOperatorStatus && (
                                        <MultiSelectOption
                                            isSelected={operator.operatorStatus === OperatorStatus.READY}
                                            onClick={props.onOperatorStatusChange ? () => props.onOperatorStatusChange(operator.email) : null}
                                        />
                                    )
                                }
                                <Text
                                    tag='div'
                                    className='operators-list__text'
                                    message={`${operator.firstName} ${operator.lastName}`}
                                    withEllipsis
                                />
                                {props.onOperatorRoleChange && (
                                    <OperatorsRoleDropdownPresentation
                                        selectedRole={operator.operatorRole}
                                        onChange={role => props.onOperatorRoleChange(operator.email, role)}
                                        shouldDisabledItems={!activeOperator}
                                    />
                                )}
                                {props.displayOperatorRole && operator.operatorRole && (
                                    <Text
                                        tag='div'
                                        className='operators-list__role'
                                        message={
                                            formatMessage({
                                                id: `oe.operators.roleOptions.${operator.operatorRole}`,
                                                description: 'Operator role option',
                                            })
                                        }

                                    />


                                )}
                                {props.removeOperator &&
                                <label
                                    onClick={() => props.removeOperator(operator.email)}
                                    className='organization__remove-label'
                                >
                                    {props.withCloseIcone
                                        ? <CloseIcon />
                                        : 'Remove'
                                    }
                                </label>}
                            </div>;
                        }
                    )) : null
                }
            </div>
    );
};

export { OperatorsList };
